import { InputRef, Space } from 'antd';
import { PropsWithChildren, Ref, useCallback } from 'react';

import { Input } from '@atom/form/input/input';
import { TestIdsEnum } from '@enum/test-ids.enum';
import { Form } from '@form/common.style';
import { FormError } from '@form/form-error';
import { initialNewApplicationForm } from '@form/new-consumer/new-consumer.form-initial';
import { BaseFormInterface } from '@interface/form/base-form.interface';
import { getTestId } from '@util/data/get-test-id';
import { isExist } from '@util/data/is-exist';

import { newConsumerFormValidation } from './new-consumer.form-validation';

export const NewConsumerForm = ({ form, children, error }: PropsWithChildren<BaseFormInterface>) => {
  const inputRef = useCallback((inputElement: InputRef) => {
    if (isExist(inputElement)) inputElement.focus();
  }, []);

  return (
    <Form autoComplete='off' form={form} initialValues={initialNewApplicationForm} layout='vertical' name='consumer'>
      <Space direction='vertical' size={24}>
        <div id='step-5'>
          <Form.Item label='Consumer name' name='name' rules={[newConsumerFormValidation]}>
            <Input
              placeholder='Ex: ConsumerX'
              ref={inputRef as Ref<any>}
              {...getTestId(TestIdsEnum.ApplicationConsumerNameInput)}
            />
          </Form.Item>
        </div>
        {children}
      </Space>
      <FormError error={error} errorField='name' />
    </Form>
  );
};
